import React, { useState } from 'react';
import emailjs from 'emailjs-com';

function Info() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send email using EmailJS
    emailjs
      .send(
        'service_fjfkav4', // Replace with your EmailJS service ID
        'template_ehpbpfy', // Replace with your EmailJS template ID
        formData,
        'gerald_ru@yahoo.com' // Replace with your EmailJS user ID
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatus('Message sent successfully!');
          setFormData({
            name: '',
            email: '',
            subject: '',
            message: '',
          });
        },
        (error) => {
          console.log(error.text);
          setStatus('Failed to send message. Please try again.');
        }
      );
  };

  return (
    <div className="sec-box contact blog section-padding bord-thin-top" id="info">
      <div className="row">
        <div className="col-lg-5">
          <div className="sec-head md-mb80 wow fadeIn">
            <h6 className="sub-title mb-15 opacity-7">Get In Touch</h6>
            <h2 className="fz-50">Let's make your brand brilliant!</h2>
            <p className="fz-15 mt-10">
              If you would like to work with us or just want to get in touch,
              we’d love to hear from you!
            </p>
            <div className="phone fz-30 fw-600 mt-30 underline">
              <a href="tel:+14168907651" className="main-color">
                +1 416 890 7651
              </a>
            </div>
            <ul className="rest social-text d-flex mt-60">
  <li className="mr-30">
    <a href="https://x.com/designhawks2017?s=21&t=haKH85oBRL8B8Bif4SN0CA" className="hover-this">
      <i className="fab fa-twitter"></i>
      <span className="hover-anim"></span>
    </a>
  </li>
  <li className="mr-30">
    <a href="https://www.linkedin.com/in/praveen-dubbaka-7576684/" className="hover-this">
      <i className="fab fa-linkedin"></i>
      <span className="hover-anim"></span>
    </a>
  </li>
  <li>
    <a href="https://www.instagram.com/design.hawks/profilecard/?igsh=MXVhbG95MXYzYXA5Nw%3D%3D" className="hover-this">
      <i className="fab fa-instagram"></i>
      <span className="hover-anim"></span>
    </a>
  </li>
</ul>
          </div>
        </div>
        <div className="col-lg-7 valign">
          <div className="full-width wow fadeIn">
            <form id="contact-form" onSubmit={handleSubmit}>
              

              <div className="controls row">
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <input
                      id="name"
                      type="text"
                      name="name"
                      placeholder=""
                      required="required"
                      value={formData.name}
                      onChange={handleChange}
                    />
                     <label htmlFor="name">Name</label>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <input
                      id="email"
                      type="email"
                      name="email"
                      placeholder=""
                      required="required"
                      value={formData.email}
                      onChange={handleChange}
                    />
                     <label htmlFor="email">Email</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group mb-30">
                    <input
                      id="subject"
                      type="text"
                      name="subject"
                      placeholder=""
                      value={formData.subject}
                      onChange={handleChange}
                    />
                    <label htmlFor="subject">Subject</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <textarea
                      id="message"
                      name="message"
                      placeholder=""
                      rows="4"
                      required="required"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                     <label htmlFor="message">Message</label>
                  </div>
                  <div className="messages">
  {status && (
    <div className="error-message">
      <i className="error-icon"></i>
      <p className="error-text">{status}</p>
    </div>
  )}
</div>
                  <div className="mt-30">
                    <button type="submit">
                      <span className="text">Send A Message</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Info;
